import React, { useContext } from "react";
import { ShopContext } from "../../context/shop-context";

export const NotaItem = (props) => {
  const { id, productName, price } = props.data;
  const { cartItems, getTotalCartAmount } = useContext(ShopContext);
  

  return (
    <div className="Nota">
      <div className="description">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <b>{productName} </b>
          <text>RP {(cartItems[id] * price).toFixed(3)}</text>
        </div>
        <text>{cartItems[id]} pcs @ RP {price} </text>
      </div>
    </div>
  );
};
